import modalStyle from "../../modals/modal.module.scss";

import { useState } from "react";
import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import CustomMenu from "components/Menu";
import { OutlineButton } from "components/buttons/OutlineButton";
import { SolidButton } from "components/buttons/SolidButton";
import ModalContainer from "components/ModalContainer";
import { ReactComponent as ChevronUp } from "assets/images/icons/icn_pagination_chevron_up_light.svg";
import { ReactComponent as ChevronDown } from "assets/images/icons/icn_pagination_chevron_down_light.svg";

const ModalDiscoverySettings = ({
  display,
  loading,
  proxyDevices,
  selectedProxyDevice,
  onSelectProxyDevice,
  onCancel,
  onSave,
}) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  const proxyDevicesItems = proxyDevices.map((device) => ({
    value: device.proxyUuid,
    label: device.deviceName,
    linkStatus: device.linkStatus,
  }));
  const selectedProxyItem = proxyDevicesItems.find((item) => item.value === selectedProxyDevice?.proxyUuid);

  const handleClose = () => {
    if (document.activeElement) {
      document.activeElement.blur();
    }

    setAnchorEl(null);
  };

  return (
    <ModalContainer display={display} modalWidth="600px">
      <div className={modalStyle.modal_Block} style={{ margin: "20px 0" }}>
        <Typography color="#707ca8" fontWeight="600" fontSize="20px">
          Discover Settings
        </Typography>
      </div>

      <div className={modalStyle["proxy-device-selection"]}>
        <div className={modalStyle.title}>Proxy Device</div>
        <Box
          onClick={(event) => {
            if (!loading) {
              setAnchorEl(event.currentTarget);
            }
          }}
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #707ca8",
            borderRadius: "8px",
            width: "99%",
            height: 32,
            bgcolor: loading ? "#f5f5f5" : "#fff",
            position: "relative",
            cursor: loading ? "default" : "pointer",
            boxSizing: "border-box",
          }}
        >
          <Typography
            sx={{
              px: "10px",
              pr: "42px",
              fontSize: theme.typography.customFontSize[2],
              color: selectedProxyItem ? "primary.main" : "primary.greyThread",
              fontWeight: theme.typography.customFontWeight[3],
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            }}
          >
            {selectedProxyItem?.label || ""}
          </Typography>
          <Box
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              width: 32,
              height: "100%",
              bgcolor: loading ? "#707ca8" : "#172264",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderTopRightRadius: 6,
              borderBottomRightRadius: 6,
            }}
          >
            {menuOpen ? <ChevronUp /> : <ChevronDown />}
          </Box>
        </Box>
        <CustomMenu
          anchorEl={anchorEl}
          open={menuOpen}
          handleMenuClose={handleClose}
          maxWidth={548}
        >
          <List
            sx={{
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              padding: "5px 10px",
              maxHeight: "180px",
              overflowY: "auto",
              overflowX: "hidden",
              boxSizing: "content-box",
            }}
          >
            {proxyDevicesItems.map((item) => (
              <ListItem
                key={item.value}
                button
                selected={selectedProxyItem?.value === item.value}
                disabled={item.linkStatus !== "online"}
                onClick={(event) => {
                  event.stopPropagation();
                  const selectedDevice = proxyDevices.find((device) => device.proxyUuid === item.value);
                  onSelectProxyDevice(selectedDevice || null);
                  handleClose();
                }}
                sx={{
                  color: item.linkStatus === "online" ? "primary.main" : "primary.greyThread",
                  margin: "5px 5px 0 0",
                  borderRadius: "5px",
                  width: "520px",
                  height: "40px",
                  "&:hover": { backgroundColor: "#e8ebfc" },
                  "&.Mui-selected": { backgroundColor: "#dbe0fc" },
                  "&.Mui-disabled": {
                    color: theme.palette.primary.greyThread,
                    opacity: 1,
                  },
                }}
              >
                <ListItemText
                  primaryTypographyProps={{
                    style: {
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      fontSize: theme.typography.customFontSize[2],
                    },
                  }}
                  primary={item.label}
                />
              </ListItem>
            ))}
          </List>
        </CustomMenu>
      </div>

      <div className={modalStyle.modal_operation}>
        <OutlineButton
          className={modalStyle.modal_cancelBtn}
          style={{ width: "195px", height: "42px", fontSize: "16px" }}
          variant="contained"
          onClick={onCancel}
        >
          Cancel
        </OutlineButton>
        <SolidButton
          className={modalStyle.modal_saveBtn}
          style={{ width: "195px", height: "42px", fontSize: "16px" }}
          variant="contained"
          disabled={loading || !selectedProxyDevice}
          onClick={onSave}
        >
          Save
        </SolidButton>
      </div>
    </ModalContainer>
  );
};

export default ModalDiscoverySettings;
